(function(){
  'use strict';
  function init(root){
    if(!root||root.dataset.r58Ready==='true')return;
    root.dataset.r58Ready='true';
    var steps=Array.prototype.slice.call(root.querySelectorAll('[data-r58-step]'));
    var progress=root.querySelector('[data-r58-progress]');
    if(!steps.length||!progress)return;
    var animate=root.dataset.animate==='true'&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var desktop=window.matchMedia('(min-width: 990px)').matches;
    var timers=[];
    var highest=-1;
    function activate(index){
      if(index<=highest)return;
      highest=index;
      for(var i=0;i<=highest;i++)steps[i].classList.add('is-active');
      var ratio=steps.length<=1?1:highest/(steps.length-1);
      if(desktop)progress.style.width=(ratio*100)+'%';else progress.style.height=(ratio*100)+'%';
    }
    if(!animate||!('IntersectionObserver'in window)){
      steps.forEach(function(s){s.classList.add('is-active');});
      if(desktop)progress.style.width='100%';else progress.style.height='100%';
      return;
    }
    if(desktop){
      var sectionObserver=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(!entry.isIntersecting)return;sectionObserver.disconnect();steps.forEach(function(step,index){timers.push(window.setTimeout(function(){activate(index);},index*130));});});},{threshold:.3});
      sectionObserver.observe(root);
      root._r58Cleanup=function(){sectionObserver.disconnect();timers.forEach(function(t){window.clearTimeout(t);});timers=[];};
    }else{
      var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){var index=parseInt(entry.target.dataset.stepIndex||'0',10);activate(index);}});},{threshold:.48,rootMargin:'0px 0px -16% 0px'});
      steps.forEach(function(step){observer.observe(step);});
      root._r58Cleanup=function(){observer.disconnect();};
    }
  }
  function scan(scope){Array.prototype.forEach.call((scope||document).querySelectorAll('[data-r58-timeline]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){scan(document);});else scan(document);
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
  document.addEventListener('shopify:section:unload',function(e){Array.prototype.forEach.call(e.target.querySelectorAll('[data-r58-timeline]'),function(root){if(typeof root._r58Cleanup==='function')root._r58Cleanup();});});
})();
